export const artavaBrand = {
  companyName: 'Artava Systems',
  shortName: 'Artava',
  productName: 'Smarti',
  websiteUrl: 'https://www.artavasystems.com/en',
  websiteHost: 'artavasystems.com',
  aboutUrl: 'https://www.artavasystems.com/en/about',
  contactUrl: 'https://www.artavasystems.com/en/contact',
  linkedInUrl: 'https://www.linkedin.com/company/artavasystems/',
  contactEmail: 'hello@artavasystems.com',
  consultationUrl: '',
  technicalAssessmentUrl: 'https://www.artavasystems.com/en/contact',
  logoSrc: '/artava-wordmark.svg',
  smartiMarkSrc: '/smarti-mark.svg',
  tagline: 'Industrial software built around real engineering workflows.',
  shortDescription: 'Custom industrial software and engineering-data platforms',
  longDescription:
    'Artava Systems develops custom embedded software, industrial applications, engineering-data platforms, and connected systems for technical teams.',
  capabilities: [
    'Industrial applications',
    'Engineering data platforms',
    'Test and validation software',
    'Production dashboards',
    'Embedded and connected systems',
    'Custom workflow software',
    'Data analysis and reporting',
    'Industrial automation integrations',
  ],
  footerAttribution: 'Built by Artava Systems',
};

export function buildMailto(subject = '', body = '') {
  const params = new URLSearchParams();
  if (subject) params.set('subject', subject);
  if (body) params.set('body', body);
  const query = params.toString();
  return `mailto:${artavaBrand.contactEmail}${query ? `?${query}` : ''}`;
}

export function getSmartiDocumentTitle(pageTitle = '') {
  const base = `${artavaBrand.productName} | ${artavaBrand.companyName}`;
  return pageTitle ? `${pageTitle} | ${base}` : base;
}

export function getDocumentTitleForPath(pathname = '/') {
  const normalizedPath = String(pathname || '/').toLowerCase();
  const titleMap = new Map([
    ['/', 'Login'],
    ['/login', 'Login'],
    ['/register', 'Register'],
    ['/account-approval', 'Account approval'],
    ['/loading', 'Loading'],
    ['/dashboard', 'Workspace selector'],
    ['/production-dashboard', 'Production dashboard'],
    ['/burn-in-dashboard', 'Burn-in dashboard'],
    ['/operations-center', 'Operations center'],
    ['/report-builder', 'Report builder'],
    ['/about-artava', 'About Artava Systems'],
    ['/support/artava', 'Support and Contact'],
    ['/admin', 'Admin panel'],
  ]);

  if (titleMap.has(normalizedPath)) {
    return getSmartiDocumentTitle(titleMap.get(normalizedPath));
  }

  if (normalizedPath.startsWith('/smarti-lab')) return getSmartiDocumentTitle('Smarti Lab');
  if (normalizedPath.startsWith('/burn-in-')) return getSmartiDocumentTitle('Burn-in analytics');
  if (normalizedPath.startsWith('/ml/')) return getSmartiDocumentTitle('ML runs');
  if (normalizedPath.startsWith('/ops-snapshot/')) return getSmartiDocumentTitle('Shared snapshot');
  return getSmartiDocumentTitle();
}

export function getArtavaCopy(isItalian) {
  return isItalian
    ? {
        attribution: 'Smarti by Artava Systems',
        attributionDetail: 'Software industriale e piattaforme dati ingegneristiche.',
        whoWeAreTitle: 'Chi siamo',
        whoWeAreBody:
          'Artava Systems sviluppa software industriale, strumenti di test e piattaforme dati attorno a workflow tecnici reali.',
        whatWeBuildTitle: 'Cosa realizziamo',
        contactTitle: 'Contatta Artava',
        supportTitle: 'Supporto e contatto Artava',
        supportBody:
          'Usa questa pagina per capire chi c’è dietro Smarti, cosa realizza Artava e come aprire un contatto tecnico.',
        ctaTitle: 'Ti serve software custom per un impianto o un sistema?',
        ctaBody:
          'Artava progetta applicazioni industriali, piattaforme dati e software tecnico attorno a requisiti operativi reali.',
        primaryCta: 'Richiedi una valutazione tecnica',
        secondaryCta: 'Visita il sito',
        consultationCta: 'Prenota una consulenza',
        requestSaved: 'Richiesta inviata. Il team Artava può ricontattarti usando i dati del tuo account.',
        requestPending: 'Esiste già una richiesta Artava in attesa per questo account.',
        requestPlaceholder:
          'Descrivi il workflow, il sistema, il dashboard o l’integrazione di cui hai bisogno.',
        requestLabel: 'Contesto della richiesta',
        requestButton: 'Invia richiesta ad Artava',
        websiteLabel: 'Sito aziendale',
        linkedInLabel: 'LinkedIn',
        emailLabel: 'Email',
        basedIn: 'Torino, Italia',
        capabilityHeading: 'Capacità dietro Smarti',
      }
    : {
        attribution: 'Smarti by Artava Systems',
        attributionDetail: 'Industrial software and engineering-data platforms.',
        whoWeAreTitle: 'Who we are',
        whoWeAreBody:
          'Artava Systems builds industrial software, test tools, and engineering-data platforms around real technical workflows.',
        whatWeBuildTitle: 'What we build',
        contactTitle: 'Contact Artava',
        supportTitle: 'Artava support and contact',
        supportBody:
          'Use this page to understand who built Smarti, what Artava delivers, and how to start a technical conversation.',
        ctaTitle: 'Need custom software for a plant or system?',
        ctaBody:
          'Artava designs industrial applications, data platforms, and technical software around real operational requirements.',
        primaryCta: 'Request a technical assessment',
        secondaryCta: 'Visit website',
        consultationCta: 'Book a consultation',
        requestSaved: 'Request sent. The Artava team can follow up using your account details.',
        requestPending: 'An Artava contact request is already pending for this account.',
        requestPlaceholder:
          'Describe the workflow, system, dashboard, or integration you want Artava to assess.',
        requestLabel: 'Request context',
        requestButton: 'Send request to Artava',
        websiteLabel: 'Company website',
        linkedInLabel: 'LinkedIn',
        emailLabel: 'Email',
        basedIn: 'Torino, Italy',
        capabilityHeading: 'Engineering capability behind Smarti',
      };
}
